import "../components/Products.css";

import MainLayout from "../layouts/MainLayout";
import ProductHero from "../components/ProductHero";
import ProductCategories from "../components/ProductCategories";
import WhyChooseProducts from "../components/WhyChooseProducts";
import IndustriesServed from "../components/IndustriesServed";
import ProductCTA from "../components/ProductCTA";

export default function Products(){
  return (
    <MainLayout>
      <ProductHero/>
      <ProductCategories/>
      <WhyChooseProducts/>
      <IndustriesServed/>
      <ProductCTA/>
    </MainLayout>
  );
}